import { render, staticRenderFns } from "./flyOldmanAdd.vue?vue&type=template&id=04177a4a&scoped=true"
import script from "./flyOldmanAdd.vue?vue&type=script&lang=js"
export * from "./flyOldmanAdd.vue?vue&type=script&lang=js"
import style0 from "./flyOldmanAdd.vue?vue&type=style&index=0&id=04177a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04177a4a",
  null
  
)

export default component.exports